var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.67 1v.002a3.31 3.31 0 0 1 3.321 2.864L23 4v7l-.009.134A3.31 3.31 0 0 1 19.67 14h-2.02l-3.736 8.407A1 1 0 0 1 13 23a4 4 0 0 1-4-4v-3H4.34v-.001a3 3 0 0 1-2.904-2.163 3 3 0 0 1-.085-1.286v-.002l1.38-9A3 3 0 0 1 5.72 1.001V1zM18 12h1.687l.12-.003A1.308 1.308 0 0 0 21 10.914V4.086A1.31 1.31 0 0 0 19.688 3H18zm-7 7a2 2 0 0 0 1.392 1.904L16 12.787V3H5.709a1 1 0 0 0-1 .85l-.001.001-1.38 8.998.001.001a1 1 0 0 0 1 1.15h5.67a1 1 0 0 1 1 1z"
  })));
};
export default Svg24;